// @flow
import React, { useState } from 'react';

import styles from './tabs.css';

type TabsPropsType = {
  children: React.ReactNode[];
  containerClassName?: any;
  defaultSelected?: number;
  onChange?: (index: number) => any;
  showDivider?: boolean;
}

const Tabs = ({
  children,
  containerClassName,
  defaultSelected,
  onChange,
  showDivider = true,
}: TabsPropsType) => {
  const [selectedTab, setSelectedTab] = useState(defaultSelected || 0);

  const onTabClick = (index) => {
    setSelectedTab(index);
    if (onChange) {
      onChange(index);
    }
  };

  const childrenWithSelectedStatus = React.Children.map(children, (child, index) => {
    return React.cloneElement(
      child,
      {
        selected: index === selectedTab,
        onClick: () => onTabClick(index),
      },
    );
  });

  return (
    <div className={styles.parent}>
      <div
        className={`
          ${styles.tabsContainer}
          ${containerClassName || ''}
        `}
      >
        {childrenWithSelectedStatus}
      </div>
      { showDivider && <div className={styles.divider} /> }
    </div>
  );
}

export default Tabs;



// WEBPACK FOOTER //
// ./src/scripts/components/Tabs/index.jsx